<!-- template for the modal component -->
<template type="x/template">
  <transition name="modal" id="contact-info-dialog">
    <div class="modal-mask" v-show="show">
      <div class="modal-container" @click.stop>
        <div class="modal-header">
          <h3 :class="[modalData.info.color]" v-if="modalData && modalData.info">{{ modalData.title }}</h3>
        </div>
        <div class="modal-body">
          <div class="row">
            <table class="table">
              <thead>
                <tr>
                  <th class="thumbnail" v-if="modalData && modalData.info" colspan="2">
                    {{ $t("tools.import_console.errors.details") }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="modalData.info && modalData.info.type === 'error'">
                <tr v-if="modalData.items && modalData.items.message">
                  <td colspan="2" class="text-danger">{{ modalData.items.message }}</td>
                </tr>
                <tr v-for="row in getErrorRows(modalData.items)" :key="row.key">
                  <td class="td-text">{{ row.label }}</td>
                  <td class="td-text">{{ row.message }}</td>
                </tr>
              </tbody>

              <tbody v-if="modalData.info && modalData.info.type === 'success'">
                <tr v-for="(row, rowKey) in modalData.items" :key="rowKey">
                  <td class="text-left" align="left">
                    <span class="rowKey text-left">{{ rowKey }}:</span>
                  </td>
                  <td class="text-left" align="left">
                    <span class="rowVal text-left">{{ row }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              v-if="
                modalData.items &&
                (modalData.items.message_type === 'structure_errors' ||
                  (modalData.items.message_type === 'validation_errors' && modalData.items.template === ''))
              "
              class="font-weight-bold"
            >
              {{ $t("tools.import_console.configure_template") }}
              <router-link
                :to="'/tools/import-configurator/templates?import_id=' + modalData.import_id + '&import_type_id=' + modalData.import_type"
              >
                {{ $t("tools.import_console.here") }}
              </router-link>
            </p>
          </div>
        </div>
        <div class="modal-footer col-lg-10">
          <div class="form-group row justify-content-end">
            <div class="col-lg-4">
              <button class="btn btn-success" @click="finish()">{{ $t("common.ok") }}</button>
            </div>
            <div class="col-lg-4">
              <button class="modal-default-button btn btn-secondary ml-3" @click="close()">{{ $t("common.close") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ImportSummaryDialog",
  props: ["show", "data"],
  data: function () {
    return {
      modalData: this.data ? this.data : {},
    };
  },
  computed: {},
  methods: {
    getErrorRows(payload) {
      const errors = payload?.errors?.error ?? payload?.errors ?? payload?.[0] ?? null;
      if (!errors) {
        return [];
      }
      if (typeof errors === "string") {
        return [{ key: "error", label: "", message: errors }];
      }

      const entries = Array.isArray(errors) ? errors.map((value, index) => [index, value]) : Object.entries(errors);
      return entries.map(([key, value]) => ({
        key: String(key),
        label: /^\d+$/.test(String(key)) ? `#${Number(key) + 1}` : String(key),
        message: this.formatErrorValue(value),
      }));
    },
    formatErrorValue(value) {
      if (Array.isArray(value)) {
        return value.map((item) => this.formatErrorValue(item)).filter(Boolean).join("; ");
      }
      if (value && typeof value === "object") {
        const details = [];
        if (value.template?.name) {
          details.push(`${this.$t("tools.import_console.matching_template")}: ${value.template.name}`);
        }
        if (Array.isArray(value.columns)) {
          details.push(`${this.$t("tools.import_console.errors.structure_failed", { count: value.columns.length })} ${value.columns.join(", ")}`);
        }
        if (details.length) {
          return details.join("; ");
        }
        return Object.entries(value)
          .map(([key, item]) => `${key}: ${this.formatErrorValue(item)}`)
          .join("; ");
      }
      return value === null || value === undefined ? "" : String(value);
    },
    close: function () {
      this.$emit("close");
    },
    finish() {
      this.$emit("onOK", this.modalData);
      this.close();
    },
  },
  watch: {
    data: {
      handler: function (newVal) {
        this.modalData = newVal;
      },
      deep: true,
    },
  },
  validations() {
    return {
      modalData: {},
    };
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.rowKey {
  text-transform: capitalize;
  font-weight: bold;
}
</style>
